import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ConfirmRequest {
  message: string;
  confirmText: string;
  cancelText: string;
  resolve: (confirmed: boolean) => void;
}

/**
 * Confirmação Sim/Não baseada em Promise — substitui o sweetalert2 (SwalService).
 * Mantém a ergonomia dos chamadores (`await`/`.then(ok => ...)`), mas renderiza um modal
 * DaisyUI via OabConfirmHostComponent (montado uma vez no app). O `message` aceita HTML.
 */
@Injectable({ providedIn: 'root' })
export class ConfirmService {
  private readonly request = new Subject<ConfirmRequest>();
  readonly requests = this.request.asObservable();

  question(
    message = 'Você tem certeza que deseja excluir este item?',
    confirmText = 'Sim',
    cancelText = 'Não',
  ): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.request.next({ message, confirmText, cancelText, resolve });
    });
  }
}
